import API_service from 'xAppLib/providers/API_service'
import db_lib from 'xAppLib/libs/db_lib';
import doc_model from './doc_model'

const _FRDB_LOC = 'doc_cat';

// The only doc fields the non-doctor consumers use - the Skype roster, the menopause follow-up and the docpay
// cosm filter. Everything else on a doc record, provider and prescriber numbers among it, stays unread by them.
const _PUBLIC_DOC_FIELDS = ['name', 'firstname', 'familyname', 'skype', 'm', 'capabilities/cosm'];
const _DET_FIELDS = [
						{
							name: "type",
							label:'Type', 
							type: "radio",
							options: [{c:'g', n:'Group'}, {c:'i', n:'Doctor'}],
							placeholder: "Type?",
							param_name: "t",
							req_label: "*",
						},
						{
							name: 'active',
							label: 'Active',
							type: 'bool',
						},
						{
							name: "code",
							type: "text",
							label: "Code",
							placeholder: "Code ID (optional)",
							// pattern: "a-zA-Z0-9_-",
							param_name: "c",
							prop_name: "k",
							req_label: "*",
							valid_not_required: true,
							view_link_to: true,
						},

						{
							name: "name",
							label:'Name', 
							type: "text",
							placeholder: "Name",
							param_name: "n",
							req_label: "*",

							view_link_to: true,
						},

						// {
						// 	name: "code",
						// 	label:'Unique code', 
						// 	type: "text",
						// 	placeholder: "Code",
						// 	pattern: "a-zA-Z0-9_-",
						// 	param_name: "c",
						// 	req_label: "*",
						// },

						{
							name: "desc",
							label:'Description', 
							type: "textarea",
							placeholder: "Description",
							param_name: "d",
							req_label: "*",
							valid_not_required: true,
						},

					];
const _MODEL_NAME = 'docs_model';

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

const cosm_base_path = '-LU96WxoXbHLbOy1vZPG/-LU96bkgGkgNBrTPe-lz'
const cosm_docs_path = cosm_base_path.replace(/\//g, '/i/') + /i/ 
const roster_path = cosm_base_path.replace(/\//g, '/i/') + /rost_weekly/ 
const GPs_path = '-M313GuMGr1fQ0xitD38/i/'

export default class docs_model extends db_lib {

	static get FRDB_LOC() { return _FRDB_LOC; }
	static get DET_FIELDS() { return _DET_FIELDS; }
	static get MODEL_NAME() { return _MODEL_NAME; }

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

	static watch_roster(day, ca) {
		const path = roster_path + (day || '')
		return docs_model.watch_record(path, ca)
	}

// ---- --------------------------------------------  --------------------------------------------  

	static async get_flat_cats() {

		const docs_recs = await this.get_record()
		// console.log({docs_recs});

		let flat_cat_list = {}

		const recur_list_trav = (cat_data, par='', par_db='', par_nm='') => (
					cat_data && 
						Object.keys(cat_data)
							// .sort( (a, b) => cat_data[a].n.localeCompare(cat_data[b].n) )
							.map(
								(objk, i) => {
										// if (cat_data[objk].active==false) return;
										// flat_cat_list[par+objk] = cat_data[objk]
										flat_cat_list[objk] = JSON.parse(JSON.stringify(cat_data[objk]));
										flat_cat_list[objk].path_name = par_nm + (par_nm&&'/'||'') + flat_cat_list[objk].n
										flat_cat_list[objk].l = par
										flat_cat_list[objk].l_db = par_db
										cat_data[objk].i && recur_list_trav(cat_data[objk].i, par+objk+'/', par_db+objk+'/i/', flat_cat_list[objk].path_name)
										delete flat_cat_list[objk].i
									}
							)
		)

		// const cat_tree_data = await cat_model.get_record()
		
		// console.log(cat_tree_data);

		recur_list_trav(docs_recs)

		// console.log('flat_cat_list', flat_cat_list);

		app.app_data.ws_data.docs = { ...app.app_data.ws_data.docs, flat_cat_list }

		return flat_cat_list;
	}

// ---- --------------------------------------------  --------------------------------------------  

	static async get_roster(day) {
		const path = roster_path + (day || '')
		return (docs_model.get_record(path)) || []
	}
	
	static save_roster(roster) {
		docs_model.set_record( roster_path, roster )
	}
	
	static async get_docs() {
		return docs_model.get_record(cosm_docs_path)
	}
	
	static async get_GPs() {
		return docs_model.get_record(GPs_path)
	}

	// Active state of every doctor in the catalogue, keyed by doc id. Mirrors the backend's
	// stats_ahpra_model.get_active_ids, which decides e.g. whether an approving doctor can sign purchase
	// orders: a doctor can be listed in several places in the tree, and is active if any of those entries
	// (leaves - nodes without children) isn't marked active: false. Doctors not in the catalogue are absent.
	static async get_active_map() {
		const tree = await docs_model.get_record('', null, {refresh: true})
		const map = {}

		const walk = (node, id, depth) => {
			if (!node || depth > 10) return
			if (node.i)
				return Object.entries(node.i).forEach( ([k, n]) => walk(n, k, depth+1) )
			map[id] = map[id] || node.active !== false
		}
		walk({i: tree}, 'root', 0)

		return map
	}
	
	static async get_docs_dets(docs) {
		if (!docs) {
			docs = await docs_model.get_docs()
			docs = Object.keys(docs)
		}
		const docs_dets = []
		await Promise.all(
				docs.map( async k => docs_dets.push({k, ...(await doc_model.get_record( k ))}) )
			)
		return docs_dets
	}

	// Options for a doctor picker. Built from `doc_cat` rather than the `docs` node: the picker needs every doctor,
	// and `docs` should not be generally readable to enumerate. `doc_cat` is readable, keyed by the same doc ids, and
	// carries the name as `n`.
	static async get_sel_docs_list(refresh = false) {
		if (refresh || !app.app_data.ws_data?.docs_sel_list) {
			// GPs and cosmetics only - the onboarding category is left out on purpose. Those doctors have no Firebase
			// claims and are marked as `active: false` until an admin promotes them, and promotion re-keys them (a
			// fresh doc_id is pushed and docs/<uid> is deleted), so anything that had stored the old doc_id would be
			// left pointing at a record that no longer exists.
			const [docs_gps, docs_cosm] = await Promise.all([docs_model.get_GPs(), docs_model.get_docs()])

			const docs_data = {'-': {n: 'Empty'}, ...docs_gps, ...docs_cosm}

			app.app_data.ws_data.docs_sel_list =
				Object.keys(docs_data).map( k => ({key: k, value: k, text: docs_data[k].n}) )
		}

		return app.app_data.ws_data.docs_sel_list
	}

	// As get_docs_dets, but reads only the fields the rules grant on individual children of `docs`, so it keeps
	// working once that node's read rule is narrowed. Callers needing the full record keep using get_docs_dets.
	static async get_docs_public_dets(docs) {
		if (!docs) {
			docs = await docs_model.get_docs()
			docs = Object.keys(docs)
		}
		return await Promise.all(
				docs.map( async k => ({k, ...(await doc_model.get_record_fields( k, _PUBLIC_DOC_FIELDS ))}) )
			)
	}

	static async get_gp_dets(docs) {
		if (!docs) {
			docs = await docs_model.get_GPs()
			docs = Object.keys(docs)
		}
		const docs_dets = []
		await Promise.all(
				docs.map( async k => docs_dets.push({k, ...(await doc_model.get_record( k ))}) )
			)
		return docs_dets
	}


	static async doc_signup (data, existing_doctor, existing_group) {
		return await API_service.load_data ('docsAdmin', {
			act: 'doc-signup',
			data: data,
			existing_doctor: existing_doctor,
			existing_group: existing_group
		})		
	}

	static async get_prefill_data() {
		try {
			return API_service.load_data('docsAdmin', {act: 'prefill'}).then(rsp => rsp.data);
		} catch (e) {
			console.error('get_prefill_data', e);
			return null;
		}
	}

	// Uploads a signature image to the 'doc-signs' bucket and returns its public URL. Shared by the
	// onboarding self-signup flow (DocSignUp.jsx) and the in-consult self-service signature flow.
	static async upload_signature_image(img, comn, filename) {
		const saved = await API_service.load_data('file/signature/store/doc-signs', {
			img_data: img,
			comn,
			fn: filename,
		})
		return 'https://storage.googleapis.com/' + saved.bct + '/' + saved.img_fn
	}

	// Lets an already-onboarded doctor/NP self-upload a signature (e.g. when prompted to add one before issuing a
	// paper script), as opposed to `doc_signup` which is only reachable by onboarding admins. Backed by the
	// 'doc-update-signature' action in instantscripts_backend (controllers/docs.js), which scopes the write to the
	// caller's own record via their `doc_id` auth claim.
	static async update_own_signature(signature) {
		return await API_service.load_data('docsAdmin', {
			act: 'doc-update-signature',
			signature,
		})
	}

	// Uploads a captured/uploaded signature image and persists it to the caller's own doctor record.
	static async save_own_signature(img, name) {
		if (!img) return ''

		const filename = `signature-${(name || 'doctor').toLowerCase().replace(/[^a-z]+/g, '-')}-${Date.now()}.png`
		const signature = await docs_model.upload_signature_image(img, name, filename)

		const res = await docs_model.update_own_signature(signature)
		if (res?.res !== 'ok') throw res?.message || 'Unable to save signature'

		return signature
	}

}
